import format from 'date-fns/format'
import { pathOr } from 'ramda'
import { addMethod, boolean, object, string } from 'yup'

import morning from 'utils/date/morning'
import { canPrePopulate, validateDob } from 'utils/date/validate'
import { transformErrors } from 'utils/errors'
import { noSpecialCharacters } from 'utils/validation-schemas/helpers'

noSpecialCharacters()

addMethod(string, 'dob', function() {
  return this.test('dob', null, function(value) {
    const { path, createError } = this

    const message = validateDob(value, morning())

    if (message === true) {
      return message
    }

    return createError({
      message,
      path,
    }) as any
  })
})

const allFields = new Map([
  [
    'firstName',
    string()
      .required('Please enter a valid first name.')
      .max(32, 'Your first name cannot exceed ${max} characters.')
      .matches(/^((?!&|\sand\s).)*$/, 'Please only enter your legal first name.')
      .excludeSpecialCharacters(),
  ],
  [
    'lastName',
    string()
      .required('Please enter a valid last name.')
      .max(32, 'Your last name cannot exceed ${max} characters.')
      .excludeSpecialCharacters(),
  ],
  [
    'dob',
    string()
      .required('Please enter a valid birthday.')
      .dob(),
  ],
  [
    'phoneNumber',
    string()
      .required('Please enter a valid phone number.')
      .matches(
        /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
        'Please enter a valid phone number.',
      )
      .test('phoneNumberTest', 'Please enter a valid phone number.', value => {
        return !new RegExp(/^\((\d)\1{2}\) \1{3}-\1{4}$/).test(value)
      }),
  ],
  ['usCitizen', boolean()],
])

const validationSchema = (fieldNames: string[]) => {
  const fields: any = {}

  fieldNames.map(fieldName => {
    fields[fieldName] = allFields.get(fieldName)
  })

  return object().shape(fields)
}

// Handles Formik's validate event.
export const validate = values => {
  let errors = {}

  try {
    validationSchema(Object.keys(values)).validateSync(values, { abortEarly: false })
  } catch (validationErrors) {
    // Convert validation errors to Formik errors collection
    errors = transformErrors(validationErrors.inner)
  }

  return errors
}

export const mapPropsToValues = ({ showPhoneNumber, showNames }) => ({ data }) => {
  const can = canPrePopulate(pathOr(null, ['profile', 'createdAt'], data))
  const source = data.user || {}

  const values: any = (({ dob, usCitizen }) => ({
    dob: can && dob ? format(dob, 'MM/DD/YYYY') : '',
    usCitizen: can && usCitizen !== null ? usCitizen : true,
  }))(source)

  if (showPhoneNumber) {
    values.phoneNumber = (can && source.phoneNumber) || ''
  }

  if (showNames) {
    values.firstName = (can && source.firstName) || ''
    values.lastName = (can && source.lastName) || ''
  } else if (!source.firstName || !source.lastName) {
    values.firstName = source.firstName || ''
    values.lastName = source.lastName || ''
  }

  return values
}
